import { render, staticRenderFns } from "./DashboardPublic.vue?vue&type=template&id=e9c88a34&scoped=true&"
import script from "./DashboardPublic.vue?vue&type=script&lang=js&"
export * from "./DashboardPublic.vue?vue&type=script&lang=js&"
import style0 from "./DashboardPublic.vue?vue&type=style&index=0&id=e9c88a34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9c88a34",
  null
  
)

export default component.exports